import * as React from "react";

export type PropertyRegistrationMode = "ai" | "manual";

export const RegistrationContext = React.createContext(false);
export type RegistrationFlow = "own" | "building" | "consideration";
export const RegistrationStepContext = React.createContext<{ flow: RegistrationFlow; step?: number }>({ flow: "own" });

export const registrationFieldLabels: Record<string, string> = {
  name: "マンション・アパート名",
  room_number: "号室",
  floor: "所在階",
  prefecture: "都道府県",
  city: "市区町村",
  town: "番地",
  block: "住所",
  railway: "路線名",
  station: "駅名",
  walk: "駅徒歩",
  built_at: "築年",
  occupied_area_m2: "専有面積",
  layout: "間取り",
  structure: "構造",
  management_type: "管理形態",
  sales_status: "売却状況",
  bought_at: "購入年月",
  bought_at_day: "購入日",
  total_price_of_property: "購入価格（税込）",
  priceof_tax: "うち消費税",
  priceof_building: "うち建物代",
  priceof_land: "うち土地代",
  priceof_facilities: "うち設備代",
  loan_amount: "ローン借入金額",
  loan_interest_rate_percentage: "借入利率（年利）",
  payment_starts_at: "初回返済月",
  payment_starts_at_day: "初回返済日",
  payment_period: "返済年数",
  monthly_fee: "家賃収入",
  monthly_management_fee: "管理費収入",
  type_of_the_income_of_the_beginning_of_contract: "契約開始時の収入",
  security_deposit: "更新料",
  key_money: "礼金",
  building_management_cost: "建物管理費",
  repair_fund_cost: "修繕積立金",
  management_cost: "賃貸管理費",
  misc_cost: "その他経費",
  other_monthly_income: "その他の収入",
  starts_at: "契約の開始月",
  starts_at_day: "契約の開始日",
  ends_at: "契約の終了月",
  ends_at_day: "契約の終了日",
  outsourcing_fee_rate_of_new_lease_contract: "新規賃貸契約手数料",
  outsourcing_fee_rate_of_updating_lease_contract: "賃貸契約更新時手数料",
  management_company_commission: "管理委託手数料",
  shared_utility_expenses: "共用部の水道光熱費",
  misc_building_cost: "その他の建物経費",
  asking_price: "希望売却価格",
  property_image: "写真",
};
